<div class="w-full h-full si-card">
    <div class="border-b px-4 py-2">
        <h3 class="pt-2">Integrations</h3>
    </div>
    <div class="content-center flex-1 p-4">
        <p class="integration-info pb-2 card-sub-integration-text text-center pb-2 text-secondary empty-state-text font-light">Let’s get you integrated for a seamless SalesIntel experience. Choose your platform to get started!</p>
        <div class="flex flex-wrap -mx-2 integration-logo">
            <ng-container *ngFor="let logo of integrationLogos">
                <div class="flex-none w-1/4 mb-2 flex cursor-pointer justify-center items-center px-2"
                    (click)="onOpenSettings(logo.modal)">
                    <img [src]="logo.src" [alt]="'Logo of ' + logo.name" class="w-full" />
                </div>
            </ng-container>
            <div class="flex-none w-1/4 mb-2 text-center cursor-pointer font-bold p-0 mt-1 content-center" [class.cursor-pointer]="((isAdmin$ | async) && (accountAttributes.APPS | hasAccess))" [class.cursor-not-allowed]="!((isAdmin$ | async) && (accountAttributes.APPS | hasAccess))"
                [matTooltip]="((isAdmin$ | async) && (accountAttributes.APPS | hasAccess)) ? null : 'Don’t see your CRM?  Ask your admin to set up a custom export app'"
                (click)="onOpenCustomSettings(modalNavigationEnum.ACCOUNT_SETTINGS)">
                <img src="../../../../../assets/icons/custom-app.svg" alt="Logo of Custom Export Apps" class="pt-4 custom-app-logo" />

                <p class="pt-1 m-0 custom-app">Custom Export Apps</p>
            </div>
        </div>
    </div>
</div>
